const REQUEST_FLOORS_BEGIN = 'app/entities/floors/REQUEST_FLOORS_BEGIN';
const REQUEST_FLOORS_SUCCESS = 'app/entities/floors/REQUEST_FLOORS_SUCCESS';
const REQUEST_FLOORS_ERROR = 'app/entities/floors/REQUEST_FLOORS_ERROR';

export default {
  REQUEST_FLOORS_BEGIN,
  REQUEST_FLOORS_SUCCESS,
  REQUEST_FLOORS_ERROR,
};
